/**
	* Author mode enum
*/
enum Author {
	Unknown,
	Public,
	Planner
}

export default Author;